import React from 'react';
import MasteredShield from '../Sparks/MasteredShield';

const STONE = { red: 'bg-red-500', amber: 'bg-amber-400', green: 'bg-green-500' };

/**
 * A row of stepping stones, one per lesson in its colour (grey = not tried), with "2/5 mastered" and a shield
 * once every lesson is green. Long topics cap the row so it never wraps a small block. `onLight` is for a white
 * background (a year-group header): untried stones go grey instead of see-through white, with no top margin.
 * A span throughout, because it sits inside buttons.
 */
export default function ProgressStones({ progress, maxStones = 12, onLight = false }) {
  if (!progress?.total) return null;
  const { bands, total, mastered } = progress;
  const allMastered = mastered === total;
  return (
    <span className={`flex items-center gap-2 ${onLight ? '' : 'mt-2'}`} role="img" aria-label={`${mastered} of ${total} lessons mastered`} data-testid="progress-stones">
      <span className="flex flex-wrap items-center gap-1">
        {bands.slice(0, maxStones).map((band, index) => (
          <span key={index} className={`h-2.5 w-2.5 rounded-full ring-1 ring-black/10 ${band === 'grey' ? (onLight ? 'bg-gray-300' : 'bg-white/50') : STONE[band]}`} data-band={band} />
        ))}
      </span>
      <span className="text-xs font-bold">
        {mastered}/{total} mastered
      </span>
      {allMastered && <MasteredShield size={18} title="Topic mastered" />}
    </span>
  );
}
